import { JSX } from 'react';
import { C30IconCTASimplifiedProps } from './C30IconCTASimplified.types';
import { IconCtaSimplified } from '@ahc-digital/component-library';
import { CreateIconCTASimplified } from './C30IconCTASimplified.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C30IconCTASimplifiedProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <IconCtaSimplified
      id={props?.params?.AnchorLinkTargetName}
      {...CreateIconCTASimplified(props)}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
    />
  );
};

export default checkDatasourceForRendering<C30IconCTASimplifiedProps>(Default);
